import axios, { AxiosResponse } from 'axios';
import { IPValueVM } from '../Models/ViewModels';
const api_url=process.env.REACT_APP_STEM_API_BASE_URL+'/api'

const headers = { 
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  } 
export const GetUserLoginInfo=(loginId:string)=>{
    return axios.get(api_url+'/Employee/GetEmployeeIDRole?username='+loginId);
}

// export const GetUserLoginAzureInfo=(loginId:string)=>{
//     return axios.get(api_url+'/Employee/IsUserIPValid?username='+loginId);
// }



export const IpUserLogin = (username:string,ipaddress:string) =>
   {
      const payload = { "uname":username,"ipaddress":ipaddress}
   
     return axios.post(api_url+'/Employee/IsUserIPValid',payload,{headers})
     
   }